<div>
  <section class="mt-section">
    <slot />

    <fou-group>
      <p v-html="date_heading"></p>
    </fou-group>
    <div class="mt-line">
      <vee-field v-model="releaseOption" type="radio" :value="releaseASAP" name="release group" v-slot="{field}">
        <input name="release group" v-model="releaseOption" :id="$vId(this, 'release-asap')" checked type="radio" :value="releaseASAP" v-bind="field"
          class="mt-checkbox" />
      </vee-field>
      <label :for="$vId(this, 'release-asap')">
        <span></span>
        <span>{{$t('pages.submissions.components.confirmation.as_soon')}}</span>
      </label>
    </div>
    <div class="mt-line">
      <vee-field v-model="releaseOption" :value="releaseSchedule" name="release group" type="radio" v-slot="{field}">
        <input name="release group" v-model="releaseOption" :value="releaseSchedule" :id="$vId(this, 'release-schedule')" type="radio"
          v-bind="field" class="mt-checkbox" />
      </vee-field>
      <label :for="$vId(this, 'release-schedule')">
        <span></span>
        <span>
          {{ $t('pages.submissions.components.confirmation.schedule_date') }} &nbsp;
          <vee-field v-model="releaseDate"
            :rules="releaseOption!==releaseASAP?`fou_date_between:${tomorrow},${one_year_later}`:''" name="release date"
            v-slot="{field}">
            <input ref="release_date" :id="$vId(this, 'release-schedule-date')" type="date" name="release date"
              v-bind="field" class="mt-input" :class="{ 'mt-input--error': Object.hasOwn(errors, 'release date') }" />
          </vee-field>
        </span>
      </label>
    </div>
    <div v-if="Object.hasOwn(errors, 'release date')">
      <p v-for="err in releaseDateErrors" class="mt-error">{{err}}</p>
    </div>
  </section>
  <section v-if="submission.status === 'in_work'" class="mt-section mt-section--submit">
    <button :id="$vId(this, 'confirm')" type="button" name="submit_submission" class="mt-button mt-group--bottom-medium" :disabled="!isEmpty(errors) || !scanStatus"
      @click="validationForReleaseDate('submit_submission')">
      {{ $t('pages.submissions.components.confirmation.submit') }}
    </button>
    <fou-group class="mt-error" v-if="submissionLimitError">
      {{$tc('pages.submissions.index.in_review_submissions_limit_reached')}}
    </fou-group>
  </section>
</div>
